// extracted by extract-css-chunks-webpack-plugin
module.exports = {"checkbox":"app-components-filter-searchandsort-multitrackfilter-multitrackfilter--checkbox"};